(ns frontend.view.entity-viewers.events.meeting-editor
  (:require
   [frontend.actions.entity :as entity-actions]
   [frontend.state.current-session :as session]
   [common.localization :as loc]
   [frontend.view.entity-viewers.events.editor-utils :as editor-utils]
   [common.schema.registry :as registry]
   [common.util :as cu]))

(defn meeting-editor
  [{:keys [state entity-id externally-passed-entity viewed-entity-id on-reset! show-expanded? modal? props
           on-success-callback!]}]
  [editor-utils/editor
   {:state                state
    :always-expanded?     show-expanded?
    :modal?               modal?
    :activity-entity-id   entity-id
    :externally-passed-entity externally-passed-entity
    :viewed-entity-id     viewed-entity-id
    :activity-entity-type :note-meeting
    :full-width?          true
    :wysiwyg-attribute    :note-meeting/message
    :placeholder          (loc/tr :meeting-editor-placeholder)
    :init-draft-state!    (fn [update-draft!]
                            (when viewed-entity-id
                              (update-draft! :common/related-entities #{viewed-entity-id}))
                            (update-draft! :note-meeting/participants #{(:db/id @session/account)})
                            (update-draft! :note-meeting/timestamp (.getTime (js/Date.))))
    :entity-schema        (registry/get-schema @session/tenant-schema :entity.type/note-meeting)
    :mandatory-field?     false
    :on-reset!            on-reset!
    :on-success-callback! on-success-callback!
    :on-submit!           (fn [data on-success! on-error!]
                            (entity-actions/*->create
                             (-> (cu/remove-nil-vals data)
                                 (assoc :entity/type :entity.type/note-meeting))
                             (fn [resp]
                               (on-success! resp)
                               (when (fn? on-success-callback!)
                                 (on-success-callback! resp)))
                             on-error!))
    :submit-button-text   (loc/tr :create-note-meeting-button)
    :disabled-button-tooltip-text (loc/tr :meeting-add-one-association)}])
